import classNames from 'classnames';
import React, { ReactNode } from 'react';
import { Label } from 'components/ui/label';
import { Icon } from 'components/ui/icon';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from 'components/ui/tooltip';

interface IProps {
  label: string | JSX.Element;
  element: string; // htmlFor
  isRequired?: boolean;
  tooltip?: string;
  checked?: boolean;
  inline?: boolean;
  /** Renders as a Bootstrap form-check label (parity with reactstrap's Label `check`). */
  check?: boolean;
  children?: ReactNode;
}

const FormLabel = ({
  label,
  isRequired = false,
  tooltip,
  element,
  inline,
  check,
  children,
  ...props
}: IProps & React.ComponentPropsWithoutRef<'label'>): JSX.Element => {
  return (
    <Label
      className={classNames(
        'body-subtext-semibold',
        'pb-1',
        inline && 'inline',
        check && 'mb-0'
      )}
      htmlFor={element}
      {...props}
    >
      {children}
      {label}
      {isRequired && <span className="text-red-400">*</span>}
      {tooltip && (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <span className="pl-1">
                <Icon name="info" size={16} className="text-gray-blue-60" />
              </span>
            </TooltipTrigger>
            <TooltipContent side="right">{tooltip}</TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}
    </Label>
  );
};
export default FormLabel;
